import React from "react";
import { OutfitImageGenerationStatus as StatusType } from "@/hooks/useOutfitImageGeneration";

interface OutfitImageGenerationStatusProps {
  status: StatusType | null;
  isGenerating: boolean;
  className?: string;
}

const OutfitImageGenerationStatus: React.FC<OutfitImageGenerationStatusProps> = ({
  status,
  isGenerating,
  className = ""
}) => {
  if (!isGenerating && status?.status !== 'error') {
    return null;
  }

  return (
    <div className={`bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700 p-4 ${className}`}>
      {isGenerating ? (
        <div className="flex items-center space-x-3">
          {/* Spinning loader */}
          <div className="relative w-6 h-6 flex-shrink-0">
            <div className="absolute inset-0 border-2 border-gray-200 dark:border-gray-700 rounded-full"></div>
            <div className="absolute inset-0 border-2 border-transparent border-t-purple-500 rounded-full animate-spin"></div>
          </div>
          
          <div className="flex-1">
            <p className="text-sm font-light text-gray-900 dark:text-gray-100 tracking-wide">
              {status?.message || 'Generating outfit image...'}
            </p>
            <div className="flex space-x-1 mt-2">
              <div className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${
                status?.status === 'generating' ? 'bg-purple-500 animate-pulse' : 'bg-gray-300 dark:bg-gray-600'
              }`}></div>
              <div className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${
                status?.status === 'downloading' ? 'bg-pink-500 animate-pulse' : 'bg-gray-300 dark:bg-gray-600'
              }`}></div>
              <div className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${
                status?.status === 'completed' ? 'bg-green-500' : 'bg-gray-300 dark:bg-gray-600'
              }`}></div>
            </div>
          </div>
        </div>
      ) : status?.status === 'error' ? (
        <div className="flex items-center space-x-3">
          <div className="w-6 h-6 text-red-500 flex-shrink-0">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
            </svg>
          </div>
          <div className="flex-1">
            <p className="text-sm font-light text-red-700 dark:text-red-400">
              {status.message}
            </p>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default OutfitImageGenerationStatus;
